import Swiper, { Navigation, FreeMode } from 'swiper';
import 'swiper/css';

/**
 * This module provides a slideshow
 */
 export class SlideshowModule {

    static name = 'slideshow';

    constructor(node) {

        this.node = node;

        // .container.max-w-screen-xl => 1280px wide (18px padding)
        const offset = Math.max(20, (window.innerWidth - (1280 - 18)) / 2)

        this.swiper = new Swiper(node, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            modules: [Navigation, FreeMode],
            navigation: {
              nextEl: '.sperson-button.next',
              prevEl: '.sperson-button.prev',
            },
            // sm:  640
            // md:  768
            // lg: 1024
            breakpoints: {
                768: {
                    spaceBetween: 48,
                    slidesPerView: 'auto',
                    centeredSlides: false,
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 64,
                    centeredSlides: false,
                    slidesOffsetBefore: offset,
                    slidesOffsetAfter: offset,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                    },
                }
            }
        });
    }
}

  